import qs from 'qs';
import { bizmatesWordbookApi } from '@/utils/bizmatesApi';
import { isStringExactMatch } from '@/utils/common';

export default {
  namespaced: true,
  state: {
    trainerTags: [],
    tagItems: [],
    editTag: null
  },
  mutations: {
    setTagItems(state, payload) {
      state.tagItems = payload;
    },
    addTrainerTags(state, payload) {
      state.trainerTags.push(payload);
    },
    setTrainerTags(state, payload) {
      state.trainerTags = payload;
    },
    setEditTag(state, payload) {
      state.editTag = payload;
    }
  },
  actions: {
    /**
     * Get set of tags
     *
     * @param {commit} commit
     * @return void
     */
    async getTags({ commit }) {
      await bizmatesWordbookApi.get('tags', {}, response => {
        commit('setTagItems', response.data.data);
      });
    },

    /**
     * Save/Update tagged word(s)/phrase(s)
     *
     * @param {commit} commit
     * @param {object} message
     * @return {object} data of tagged word(s)/phrase(s)
     */

    async saveTrainerTag({ commit, state }, message) {
      const params = {
        lesson_id: this.state.lessonId,
        message_id: message.id
      };

      const data = state.trainerTags
        // filter exact tagged words not included on chat message
        .filter(tag => isStringExactMatch(message.text, tag.word.trimEnd()) || tag.tagged_word_id)
        .map(finalTag => {
          return {
            ...finalTag,
            ...params,
            tagged_word_id: finalTag.tagged_word_id || message.tagWordId,
            tag_ids: isStringExactMatch(message.text, finalTag.word) ? finalTag.tag_ids : null
          };
        });

      if (!data.length) {
        commit('setTrainerTags', []);
        return;
      }

      const stringifyData = qs.stringify({ data }, { strictNullHandling: true });
      return await bizmatesWordbookApi.post('trainertag', stringifyData, {}, response => {
        commit('setTrainerTags', []);
        return response.data.data;
      });
    }
  }
};
